<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h2 class="h2f"><a id="page_ix"></a>Acknowledgements</h2>
</header>
<p class="para">When Hugh Andrew approached me with the idea of this book, I was immediately attracted. There is much more to the story of the Christian conversion of the west and north of Scotland than Columba. But sources for the lives and works of the other holy men who sailed amongst the islands and sea lochs from the sixth to the eight centuries are vanishingly scant. Sometime only names and the whispers of half-forgotten stories survive. And so it seemed to me that I should do what they did, go on a journey and try to discover something of their passing, and why they founded their communities on the islands and remote places of the Atlantic shore. Blessed with sun, calm seas and enough solitude, I spent a summer in the company of the saints who came to the Hebrides all that long time ago and who did so much to shape modern Scotland.</p>
<p class="indent-para">I’m grateful to Calum Macdonald for permission to reproduce the text of <em>An Ubhal as Airde</em> (copyright © C. &amp; R. Macdonald and published by Chrysalis/BMG). The lines from Sorley MacLean’s ‘Hallaig’ are copyright © the estate of Sorley MacLean. The poem appears in <em>A White Leaping Flame/Caoir Gheal Leumraich: Sorley MacLean, Collected Poems</em>, edited by Christopher Whyte and Emma Dymock, published by Polygon in association with Carcanet Press.</p>
<p class="indent-para">Patricia Marshall is a mistress of her craft and edited this book with immense skill and sensitivity, while Andrew Simmons produced it with tact, patience and persistence. I would like to thank them both, kind and considerate professionals that they are. Jan Rutherford completes the quartet who brought this book to life. As ever, I am immensely grateful to her. My agent, David Godwin, also encouraged me greatly. And finally, for wonderful Highland hospitality, I would like to thank Mrs Flora MacRae.</p>
<p class="right1">Alastair Moffat</p>
<p class="right">Summer 2020</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?9d1185b4